import type { RUMEntry } from "@fiverr-private/relay-sdk";
import type { CustomMarkName } from "../customMarkNames";
import { customMarkNames } from "../customMarkNames";

export function includeEvent({ entryType, name }: RUMEntry): boolean {
    switch (entryType) {
        case "mark":
            return customMarkNames.has(name as CustomMarkName);
        default:
            return true;
    }
}
